import React, { PropsWithChildren } from 'react'
import { Link, usePage } from '@inertiajs/react'
import logo from '@/assets/easibuy_logo_color.png'
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, DropdownMenuSeparator } from '@/components/ui/dropdown-menu'
import { LogOutIcon, ChevronDownIcon, SettingsIcon } from 'lucide-react'

interface NavLinkProps {
  href: string;
  children: React.ReactNode;
}

const NavLink = ({ href, children }: NavLinkProps) => {
  const { url } = usePage()
  const active = url.startsWith(href)

  return (
    <Link
      href={href}
      className={`
        px-4 flex items-center h-full border-b-[3px] text-sm
        ${active
          ? 'border-blue-600 text-blue-600'
          : 'border-transparent hover:text-blue-600 hover:border-blue-600/50'
        }
      `}
    >
      {children}
    </Link>
  )
}

const UserDropdown = () => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="flex items-center gap-2 text-sm text-gray-700 h-full focus:outline-none">
        <div className="w-8 h-8 rounded-full bg-blue-600 text-white flex items-center justify-center">
          N
        </div>
        nolan@easibuy.com
        <ChevronDownIcon className="w-4 h-4" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-[200px]">
        <DropdownMenuItem>
          <SettingsIcon className="w-4 h-4 mr-2" />
          <span>Settings</span>
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem>
          <LogOutIcon className="w-4 h-4 mr-2" />
          <span>Logout</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export default function MainLayout({ children }: PropsWithChildren) {
  return (
    <div>
      {children}
    </div>
  )
}
